import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["distance"];
import styled from 'foundations-theming/utils';
import { toShorthandSize } from '../../utils/tShirtSizes';
import { DISTANCE_SIZES } from '../../utils/distance';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { SIZE } from '../../../constants/nonTokenisedValues';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledHR = styled.hr.withConfig({
  displayName: "HR__StyledHR",
  componentId: "sc-1bdxp74-0"
})(({
  $distance,
  theme,
  $cssStyles
}) => {
  return Object.assign({
    border: theme.borderWidth['0'],
    height: SIZE.HR,
    /* although this is a backgroundColor, a border token makes sense because it's intention is to act as a border */
    backgroundColor: theme.color['border-core-subtle'],
    /* Set min-height and width so that it will never be shrunk inside a flex container */
    minHeight: SIZE.HR,
    width: '100%',
    marginBlock: theme.space[DISTANCE_SIZES[toShorthandSize($distance)]]
  }, $cssStyles);
});
export const HR = _ref => {
  let {
      distance = 'md'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledHR, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    $distance: distance
  }));
};
HR.displayName = 'HR';